import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import aliOSS from 'ali-oss'
import useTitle from '../../../../hooks/useTitle'
import { message, Alert } from 'antd'
import styles from './index.module.scss'
import Skeleton from '../components/Skeleton'
import request from '../../../../network/request'
import ImageViewer from '../../../../components/ImageViewer'
import { Placeholder } from '../components/Placeholder'
import { base64url_encode } from '../../../../utils/base64'
import { formatTimestamp } from '../../../../utils/format'

const MAX_IMG_NUM = 9
const FILE_MAX_SIZE = 1024 * 1024 * 10
const ALLOW_FILE_TYPE = 'jpg, jpeg, png'

const SHOW_ADD_STATUS = 7

const WATERMARK_DEFAULT_CONFIG = 'color_FFFFFF,size_60,shadow_90'

export default function LookAround() {
  useTitle('环车检查')
  const history = useHistory()
  const { orderId } = useParams() as any
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [imageList, setImageList] = useState<any[]>([])
  const [previewList, setPreviewList] = useState<any>([])
  const [remark, setRemark] = useState('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)

  const [isUploadingg, setIsUploading] = useState(false)

  const [isPreview, setIsPreview] = useState(false)
  const [previewIndex, setPreviewIndex] = useState(0)

  const [curAddress, setAddress] = useState('')

  const fileInputRef = useRef<any>()

  useEffect(() => {
    if (orderId) {
      getOrderDetail()
    }

    return () => {
      message.destroy()
    }
  }, [orderId])

  useEffect(() => {
    if (window.xdragon) {
      window.xdragon
        .callHandler('getCurrentLocation', {})
        .then((res) => {
          console.log('location success --->', res)
          if (res?.data?.addr || res?.addr) {
            setAddress(res?.data?.addr || res?.addr)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [])

  const getOrderDetail = async () => {
    setIsLoading(true)
    const loaded = message.loading('加载中...', 0)
    try {
      const orderDetail: any = await request.get(
        '/dragon/service/order/detail',
        {
          params: {
            orderId,
          },
        }
      )
      setOrderInfo(orderDetail)

      setImageList(orderDetail?.surroundCheckDetails?.attachmentList || [])
      setRemark(orderDetail?.surroundCheckDetails?.remark || '')
    } catch (err) {
      setIsError(true)
    } finally {
      loaded()
      setIsLoading(false)
    }
  }

  const handleChange = (e) => {
    const inputTxt = e.target.value
    setRemark(inputTxt)
  }

  const handleClosePreview = () => {
    setPreviewList([])
    setPreviewIndex(0)
    setIsPreview(false)
  }

  const handlePreview = (index) => {
    let imgs: string[] = []
    imageList.map((item) => {
      imgs.push(item.url)
    })

    setPreviewIndex(index)
    setPreviewList(imgs)
    setIsPreview(true)
  }

  const handleUploadImg = () => {
    if (!isUploadingg) {
      fileInputRef.current.click()
    }
  }

  const handleRemove = (e, index) => {
    e.stopPropagation()
    let newImageList = imageList.slice()
    newImageList.splice(index, 1)
    setImageList(newImageList)
  }

  const getIndex = () => {
    const lastImg: any = imageList[imageList.length - 1]

    if (lastImg?.fileName) {
      const imgName = lastImg.fileName
      const index = imgName.split('-')[1]
      return index ? Number(index) : 1
    } else {
      return 0
    }
  }

  const onFileChange = async (event) => {
    const files = event.target.files
    const filesArr = Array.from(files) as any[]
    let curIndex = getIndex() + 1

    if (
      filesArr.length > MAX_IMG_NUM ||
      filesArr.length + imageList.length > MAX_IMG_NUM
    ) {
      message.error(`最多允许上传 ${MAX_IMG_NUM} 张照片`)
      return
    }

    const loaded = message.loading('上传中...', 0)
    let errorCode: number[] = []

    let uploadFileIndex = 0
    for (let fileIndex = 0; fileIndex < filesArr.length; fileIndex++) {
      const indexExt = filesArr[fileIndex]?.name?.lastIndexOf('.')
      if (indexExt > -1) {
        const ext = filesArr[fileIndex]?.name?.substr(indexExt + 1)
        if (!ALLOW_FILE_TYPE.includes(ext)) {
          errorCode.push(1)
          continue
        }
      } else {
        errorCode.push(1)
        continue
      }

      if (filesArr[fileIndex]?.size > FILE_MAX_SIZE) {
        errorCode.push(2)
        continue
      }

      const curFileName = `${orderInfo.id}-${curIndex + uploadFileIndex}`

      try {
        setIsUploading(true)
        const ossToken: any = await request.get(
          '/dragon/service/aliyun/token',
          {
            params: {
              fileName: curFileName,
            },
          }
        )

        if (ossToken) {
          const ossClient = await new aliOSS({
            accessKeyId: ossToken.accessKeyId,
            accessKeySecret: ossToken.accessKeySecret,
            stsToken: ossToken.securityToken,
            region: 'oss-cn-hangzhou',
            bucket: ossToken.bucket,
            secure: true,
          })
          const filePath = ossToken.path
          const fileUrl = ossToken.url

          const uploadRes: any = await ossClient.put(
            filePath,
            filesArr[fileIndex]
          )

          if (uploadRes?.res?.statusCode === 200) {
            uploadFileIndex++
            // 上传成功
            // 添加水印配置
            const watermarkConfig = [
              `text_${base64url_encode(
                formatTimestamp(new Date().getTime())
              )},g_ne,${WATERMARK_DEFAULT_CONFIG}`,
              `text_${base64url_encode(
                orderId
              )},g_ne,y_70,${WATERMARK_DEFAULT_CONFIG}`,
              `text_${base64url_encode(
                orderInfo.plateNo || orderInfo.vin
              )},g_ne,y_140,${WATERMARK_DEFAULT_CONFIG}`,
              `text_${base64url_encode(
                (curAddress || orderInfo.reserveAddress).slice(-21)
              )},g_ne,y_210,${WATERMARK_DEFAULT_CONFIG}`,
            ]

            setImageList((prevState) => {
              return [
                ...prevState,
                {
                  fileName: curFileName,
                  url: `${fileUrl}?x-oss-process=image/watermark,${watermarkConfig.join(
                    '/watermark,'
                  )}`,
                },
              ]
            })

            if (fileIndex === files.length - 1) {
              handleStopUpload(loaded)

              if (errorCode.includes(1)) {
                message.warn(`只能上传 ${ALLOW_FILE_TYPE} 格式的图片`)
              } else if (errorCode.includes(2)) {
                message.warn('只能上传小过 10M 的图片')
              }
            }
          } else {
            throw new Error('上传失败')
          }
        }
      } catch (err) {
        handleStopUpload(loaded)
        message.error('上传失败')
      }
    }
  }

  const handleStopUpload = (loaded) => {
    loaded()
    setIsUploading(false)
  }

  const handleSubmit = async () => {
    if (imageList.length === 0) {
      message.warning('请上传环车检查图片')
      return
    }
    const loaded = message.loading('正在提交...', 0)
    try {
      await request.post('/dragon/service/order/surround/check/submit', {
        orderId: orderInfo.id,
        attachmentList: imageList,
        remark: remark,
      })
      history.goBack()
    } catch (err) {
      console.log(err)
    } finally {
      loaded()
    }
  }

  if (isLoading) {
    return <Skeleton />
  }

  if (isError || !orderId) {
    return <Placeholder type="error"></Placeholder>
  }

  return (
    <div className={styles.pageLookAround}>
      {orderInfo.status < SHOW_ADD_STATUS && (
        <Alert
          className={styles.uploadTipBanner}
          message={`只能上传 ${ALLOW_FILE_TYPE} 格式的照片，最多上传 ${MAX_IMG_NUM} 张，单张照片大小不能超过 10M`}
          type="warning"
        />
      )}
      {(imageList.length > 0 || orderInfo.status < SHOW_ADD_STATUS) && (
        <div className={styles.imgWrap}>
          {imageList.map((image, imageIndex) => {
            return (
              <div className={styles.imgItemWrap}>
                <div
                  className={styles.imgContainer}
                  key={imageIndex}
                  onClick={() => handlePreview(imageIndex)}
                >
                  <img className={styles.imgItem} src={image.url} alt="" />
                </div>
                {orderInfo.status < SHOW_ADD_STATUS && (
                  <div
                    className={styles.removeIcon}
                    onClick={(event) => handleRemove(event, imageIndex)}
                  ></div>
                )}
                <p className={styles.fileName}>{image.fileName}</p>
              </div>
            )
          })}
          {imageList.length < MAX_IMG_NUM &&
            orderInfo.status < SHOW_ADD_STATUS && (
              <div className={styles.addImgPlacehold} onClick={handleUploadImg}>
                <div className={styles.addIcon}></div>
              </div>
            )}
        </div>
      )}
      <div className={styles.remarkWrap}>
        <p className={styles.remarkTitle}>备注</p>
        <textarea
          value={remark}
          disabled={orderInfo.status >= SHOW_ADD_STATUS}
          onChange={(e) => handleChange(e)}
          placeholder="请输入备注信息"
          rows={5}
          maxLength={500}
          className={styles.textarea}
        />
        <p className={styles.maxLenTip}>{remark.length}/500</p>
      </div>

      {orderInfo.status < SHOW_ADD_STATUS && (
        <div className={styles.submitBtnWrap}>
          <div className={styles.submitBtn} onClick={handleSubmit}>
            提交
          </div>
        </div>
      )}

      <input
        className={styles.uploadFileInput}
        type="file"
        ref={fileInputRef}
        multiple
        accept="image/jpeg,image/jpg,image/png"
        onChange={onFileChange}
      />

      {isPreview && (
        // @ts-ignore
        <ImageViewer
          onClose={handleClosePreview}
          urls={previewList}
          index={previewIndex}
        />
      )}
    </div>
  )
}
